// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1ds-X6dvBDSBMyePGvMNtn","icon":"XnfEesM4lwOtQ5UWwDF_i","active":"_1e-PvwoIf8j0AJFGOlFgrA"};